import { render, staticRenderFns } from "./SalonDocs.vue?vue&type=template&id=33f777e0&scoped=true"
import script from "./SalonDocs.vue?vue&type=script&lang=ts"
export * from "./SalonDocs.vue?vue&type=script&lang=ts"
import style0 from "./SalonDocs.vue?vue&type=style&index=0&id=33f777e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f777e0",
  null
  
)

export default component.exports